<template>
  <div class="buttons">
    <b-tooltip
      v-if="!!reorderIsAvailable()"
      label="Reorder specific items."
      style="margin-right:10px;"
      size="is-small"
      type="is-light"
      multilined>
      <a
        class="button is-warning"
        :href="'/reorder/' + encodeURIComponent(orderInfo.reference)"
      >
        <span style="margin-right:10px;"><b-icon pack="fa" icon="cart-arrow-down" size="is-small"/></span> Reorder
      </a>
    </b-tooltip>

    <b-tooltip
      label="Create the new order with the same products."
      style="margin-right:10px;"
      size="is-small"
      type="is-light"
      multilined>
      <b-button
        v-on:click="orderAgain"
      >
        <span style="margin-right:6px;"><b-icon pack="fa" icon="cart-arrow-down" size="is-small"/></span> Order again
      </b-button>
    </b-tooltip>

    <b-tooltip
      v-if="orderInfo.is_cancelable === true"
      label="Cancel the order on cloudprinter.com and production."
      style="margin-right:10px;"
      size="is-small"
      type="is-light"
      multilined>
      <b-button
        type="is-danger"
        v-on:click="orderCancel"
      >
        <span style="margin-right:6px;"><b-icon pack="fa" icon="ban" size="is-small"/></span> Cancel order
      </b-button>
    </b-tooltip>
  </div>
</template>

<script>
import Cloudprinter from '@/services/CloudprinterService'
import NotificationService from '@/services/NotificationService'
import Configuration from '@/utils/configuration'
import {getUniqueFileTypes} from '../../utils/file-types';

export default {
  name: 'ActionsList',
  props: {
    orderInfo: Object
  },
  data () {
    return {}
  },
  methods: {
    orderCancel: function () {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to <b>cancel</b> the order?',
        confirmText: 'Cancel order',
        cancelText: 'Close',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('loader/show')
          Cloudprinter.orderCancel(this.orderInfo.reference)
            .then(() => {
              NotificationService.message('Order ' + this.orderInfo.reference + ' was successfully canceled.')
              this.$emit('updateOrdersList')
              this.$emit('close')
            })
            .catch(() => {
              NotificationService.warning('Order ' + this.orderInfo.reference + ' can`t be canceled. Please, write to support')
            })
            .finally(() => {
              this.$store.dispatch('loader/hide')
            })
        }
      })
    },

    reorderIsAvailable: function () {
      if (Configuration.value('reorderFeatureIsEnabled') !== 'true') {
        return false
      }

      for (let item of this.orderInfo.items) {
        if (item.is_reordable === true) {
          return true
        }
      }

      return false
    },

    orderAgain: async function () {
      await this.initOrderData(this.orderInfo)
      this.$router.push('/order/create')
    },

    initOrderData: async function (originOrder) {
      this.$store.dispatch('cart/clearCart')

      for (let orderItem of originOrder.items) {
        let productInfo = await this.getProductInfo(orderItem.product_reference)
        let productOptions = {}

        for (let option of orderItem.options) {
          if (option.option_reference === 'archive_total_files') {
            productOptions.archive_total_files = option.count
          } else if (['total_pages', 'count_pages'].indexOf(option.option_reference) !== -1) {
            productOptions.count_pages = option.count
          } else {
            productOptions[option.type] = option.option_reference
          }
        }

        let originalFileLinks = {}
        let defaultFiles = {}
        let defaultDropboxFiles = {}
        let requiredFiles = getUniqueFileTypes(productInfo, productOptions);
        for (let file of requiredFiles) {
          for (let orderItemFile of orderItem.files) {
            if (orderItemFile.type === file.type) {
              originalFileLinks[file.type] = orderItemFile.url
            }
          }

          defaultFiles[file.type] = null
          defaultDropboxFiles[file.type] = {}
        }

        let productData = {
          cp_product_reference: orderItem.product_reference,
          cp_product_category: productInfo.category,
          cp_product_sub_category: productInfo.sub_category,
          file_storage: {},
          required_files: requiredFiles,
          cp_files: {
            original: originalFileLinks,
            link: defaultFiles,
            upload: defaultFiles,
            dropbox: defaultDropboxFiles
          },
          cp_product_options: productOptions,
          quantity: orderItem.count,
          cpProductInfo: productInfo,
          type: orderItem.type
        }

        for (let file of productInfo.files) {
            productData.file_storage[file.type] = 'original_file'
        }

        this.$store.dispatch('cart/addProduct', productData)
      }

      this.$store.dispatch('cpOrder/setAddress', originOrder.addresses[0])
      this.$store.dispatch('cart/updateAddress', originOrder.addresses[0])
    },
    getProductInfo: async function (productReference) {
      this.$store.dispatch('loader/show')

      try {
        const productInfoResponse = await Cloudprinter.getProductInfo(productReference)
        if (productInfoResponse) {
          return productInfoResponse.data
        }
      } catch (e) {
        NotificationService.warning('Something went wrong.')
      } finally {
        this.$store.dispatch('loader/hide')
      }
    }
  }
}
</script>
